import React, { FC, useContext, useEffect } from 'react';

import LeftArrow from '@material-ui/icons/ChevronLeftRounded';
import { RouteComponentProps } from '@reach/router';

import { GlobalContext } from '../../../store';

import Button from '../../../components/Button';
import EventContent from '../../../components/NextEvent/Components/EventContent/EventContent';
import List from '../../../components/Lists/List/List';
import { PX } from '../../../contrib/ui';
import PlayerProfileBasic from './PlayerProfileBasic';
import HandicapIndex from '../../../components/HandicapIndex';
import { placeholderImage } from '../../../assets/images';
import { useRouteInfoState } from '../../../components/RouteInfo/Context/RouteInfo.context';

interface IProps extends RouteComponentProps {
  playerId: number;
}

const Profile: FC<IProps> = props => {
  const { playerId } = props;

  const {
    actions: {
      profile: { get: getProfile },
      events: { getAllEvents }
    },
    events,
    profile
  } = useContext(GlobalContext);

  const { clubId } = useRouteInfoState();

  useEffect(() => {
    getProfile(playerId);
    getAllEvents().catch();
  }, [playerId]);

  const goBack = (): void => {
    window.history.back();
  };

  const player = profile[playerId];

  const playerEvents = Object.values(!!player && !!player.events ? events.all : []).filter(item =>
    clubId
      ? player.events.includes(item.id) && item.club.id === Number(clubId)
      : player.events.includes(item.id)
  );

  const style = placeholderImage
    ? {
        backgroundImage: `linear-gradient(0deg, rgba(0,0,0,0) 0%, #373737 100%), url(${placeholderImage})`,
        backgroundPosition: '0%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }
    : {};

  const totalHeight = 235 + 15;
  const marginSpace = PX > 1 && PX < 1.66 ? -12 : PX >= 1.66 ? -37 : 15;

  return (
    <div className="profile wrapper">
      <div>
        <div className="inner-container">
          <div className="image-container" style={style} />

          <div className="profile-container">
            <div className="back-button-container">
              <Button onClick={() => goBack()} className="back-button override" variant="text">
                <LeftArrow className="left-arrow-icon" />
                BACK TO PLAYER ROSTER
              </Button>
            </div>

            <PlayerProfileBasic user={player} />

            <HandicapIndex title={'Handicap Info'} />

            <div className="events-list">
              <List
                title="EVENTS PLAYED"
                items={playerEvents}
                itemHeight={(totalHeight + marginSpace) * PX}
                renderItem={EventContent}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
